// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './custom-field.provider';
export * from './custom-fields.module';
// @endindex